if (!customElements.get('product-form')) {
  
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      } 
      openCustom(openDrawer = true) {
        fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`)
            .then(response => response.json())
            .then(response => {
               this.cart.renderContentsCustom(response, openDrawer);
            })
            .catch(error => console.error('Error fetching cart data:', error));
      } 
      onSubmitHandler(evt) {
        evt.preventDefault();
        openCart();
        let button = $(this);
        let form = button.closest('.dev_atc_form');
        let loader = form.find(".pdp-loader");
        loader.css('display', 'block');
        $(document).find('.uc-c-cart-loader').css({'display': 'flex'});
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

         this.handleErrorMessage();

        // this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        // this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            $(document).find('.uc-c-cart-loader').css({'display': 'none'});
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            // this.querySelector('.loading__spinner').classList.add('hidden');
            let button = $(this);
            let form = button.closest('.dev_atc_form');
             var pathname = window.location.pathname;
             $("#cart-drawer-unique").removeClass("is-empty"); 
            /* epsilon API start */
            
            var pathname = window.location.pathname;
            console.log('Current Pathname:', pathname);
            console.log('Full URL:', window.location.href);
            
            var isCollectionPage = pathname.indexOf('/collections/') !== -1;
            var isProductPage = pathname.indexOf('/products/') !== -1;
             var productid = button.closest('.dev_atc_form').attr('data-proid');
             var producttype = button.closest('.dev_atc_form').attr('product-type');
            var customerId = localStorage.getItem('kp_customer_id');
            function loadScript(url) {
              const script = document.createElement('script');
              script.src = url;
              document.body.appendChild(script);
          }
          // Load script based on the page type
          if (isCollectionPage) {
              loadScript(`https://dtm.dotandkey.com/profile/visit/js/1_0?dtm_cid=83609&dtm_cmagic=6fcb57&dtm_fid=6986&dtm_promo_id=5${customerId ? `&dtm_user_id=${customerId}` : ''}&dtm_email_hash=null&dtmc_department=${producttype}&dtmc_product_id=${productid}&dtm_clear_tag=all&dtmc_loc=https%3A%2F%2Fwww.dotandkey.com%2F&cachebuster=${new Date().getTime()}`);
          } else if (isProductPage) {
              loadScript(`https://dtm.dotandkey.com/profile/visit/js/1_0?dtm_cid=83609&dtm_cmagic=6fcb57&dtm_fid=6986&dtm_promo_id=6${customerId ? `&dtm_user_id=${customerId}` : ''}&dtmc_department=${producttype}&dtmc_product_id=${productid}&dtm_clear_tag=all&dtmc_loc=https%3A%2F%2Fwww.dotandkey.com%2F&cachebuster=${new Date().getTime()}`);
          } else {
              loadScript(`https://dtm.dotandkey.com/profile/visit/js/1_0?dtm_cid=83609&dtm_cmagic=6fcb57&dtm_fid=6986&dtm_promo_id=5${customerId ? `&dtm_user_id=${customerId}` : ''}&dtm_email_hash=null&dtmc_department=${producttype}&dtmc_product_id=${productid}&dtm_clear_tag=all&dtmc_loc=https%3A%2F%2Fwww.dotandkey.com%2F&cachebuster=${new Date().getTime()}`);
          }
            /* epsilon API end */
            let loader = form.find(".pdp-loader");
            loader.css('display', 'none');
            applyCartEmptyStyles();
            var totalCount = $(document).find('.dev_getTotalCountFromDrawer').text().replace(/[()]/g, '').trim();
            $(document).find('.dev_cart_count').text(totalCount);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
function openCart(){
  setTimeout(function() {
    $('cart-drawer#cart-drawer-unique').addClass('active');
  }, 200);
}